import { SUPPORT_SESSION_ROUTE_QUERY_KEY } from './components/providers/SupportSessionProvider.vue'

/**
 * Opens a new tab at `rootHref` with `?support-session-id=<sessionId>`
 * appended. The only place in the codebase that writes the support-session
 * id into a URL.
 *
 * Used for the single "Start Support Session" transition, where the source
 * tab has no prior support session in its sessionStorage and therefore
 * cannot propagate one via browser inheritance. Every other tab-open
 * preserves the support session via sessionStorage inheritance from a
 * plain `window.open(href, '_blank')` — no URL injection needed.
 *
 * Do not pass `'noopener'` as a third `window.open` argument on internal
 * navigations: it detaches the new tab's browsing context group and breaks
 * sessionStorage inheritance for any subsequent tab opened from it.
 */
export function openSupportSessionTab(
  sessionId: string,
  rootHref: string
): void {
  const url = new URL(rootHref, window.location.origin)
  url.searchParams.set(SUPPORT_SESSION_ROUTE_QUERY_KEY, sessionId)
  window.open(url.toString(), '_blank')
}
